module.exports = __webpack_public_path__ + "img/2000_5e33f41f67001.94d22924.png";